import script from "./SeriesDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./SeriesDrawer.vue?vue&type=script&setup=true&lang=js"

import "./SeriesDrawer.vue?vue&type=style&index=0&id=35b26b40&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b26b40"]])

export default __exports__